module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_red_back.2e0c6736.svg";